import context from '@truckdown/components-systems';
import { defineComponent, ref, Ref, onMounted, watch, computed } from "vue";
import { FindLocationsUsingAccounts, ILocationQueryService } from '@truckdown/locations';

interface IData {
    listingListUnfiltered: Ref<ISelectItem[]>,
    selectedListing: Ref<ISelectItem | null>,
    showListingList: Ref<boolean>,
    searchTermListing: Ref<string>,
    accountNumber: Ref<string>,
};

export interface ISelectItem {
    value: string,
    display: string,
    terms?: string
};

const getInitialData = function (props: any) {
    return {
        listingListUnfiltered: ref<ISelectItem[]>([]),
        selectedListing: ref<ISelectItem | null>(null),
        showListingList: ref<boolean>(false),
        searchTermListing: ref<string>(""),
        accountNumber: ref<string>("")
    }
};

const getComputed = function (data: IData) {
    return {
        listingList: computed(() => {
            var term = data.searchTermListing.value.trim();
            if (term.length == 0) {
                return data.listingListUnfiltered.value;
            } else {
                return data.listingListUnfiltered.value
                    .filter((v) => {
                        return v.display.toLowerCase().indexOf(term.toLowerCase()) >= 0;
                    });
            }
        })
    };
};

const getMethods = function (data: IData, ctx: any) {

    return {
        selectListing: function (listing?: ISelectItem) {
            if (listing) {
                data.selectedListing.value = listing;
                ctx.emit('select-listing', listing);
            } else {
                data.selectedListing.value = null;
                ctx.emit('select-listing', null);
            }
            data.searchTermListing.value = "";
            data.showListingList.value = false;
        }
    }
}

const getListings = async function (data: IData, accId: string) {

    let mgr = await context.getService<ILocationQueryService>('ILocationQueryService');
    await mgr.findListings({
        accountIds: [accId],
        tags: ['#active'],
        limit: 10000
    } as FindLocationsUsingAccounts)
        .then((res) => {
            data.listingListUnfiltered.value = res.results.map(r => ({
                value: r.id,
                hours: r.hoursData,
                display: `${r.name} (${r.location.city} -  ${r.location.regionCode})`,
                terms: r.location.countryCode
            })).sort((a, b) => {
                if (a.display < b.display) {
                    return -1;
                }
                if (a.display > b.display) {
                    return 1;
                }
                return 0;
            });
        })
        .catch((reason) => {
            console.log(reason);
        });
}

export default defineComponent({
    name: "ListingLookup",
    props: {
        accountId: {
            type: String,
            required: false
        },
        listingId: {
            type: String,
            required: false
        },
        hideLabel: {
            type: Boolean,
            required: false
        },
        isError: {
            type: Boolean,
            required: false
        },
        clearListing: {
            type: Boolean,
            required: false
        }
    },
    emits: ['select-listing'],
    setup: function (props, ctx) {
        let data = getInitialData(props);
        let computed = getComputed(data);
        let methods = getMethods(data, ctx);

        onMounted(async () => {
            await getListings(data, props.accountId || "");

            if (props.listingId && props.listingId.length > 0) {
                let setListing = data.listingListUnfiltered.value.filter(l => {
                    return l.value == props.listingId;
                });

                if (setListing && setListing.length == 1) {
                    methods.selectListing(setListing[0] as ISelectItem);
                }
            }
        });

        watch(() => props.clearListing, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                if (newVal) {
                    data.selectedListing.value = null;
                    ctx.emit('select-listing', null);
                } 
            }
        });

        return {
            ...data,
            ...computed,
            ...methods
        };
    }
});
